import { useEffect } from "react";
import { PAID, isPreviewExpired } from "../../config/preview";
import { PreviewWatermark } from "./PreviewWatermark";
import { PreviewTopBar } from "./PreviewTopBar";
import { ExpiredScreen } from "./ExpiredScreen";

// Root-level gate.
// - PAID = true  → renders children only (no bar, no watermark, no expiry).
// - Preview expired → renders the expired full-screen replacement.
// - Otherwise → renders children plus the top bar and diagonal watermark,
//   and adds a `preview-mode` class on <html> so the sidebar / mobile menu
//   btn shift below the 40px top bar via a CSS variable.
export function PreviewGate({ children }) {
  useEffect(() => {
    const root = document.documentElement;
    if (!PAID) root.classList.add("preview-mode");
    else root.classList.remove("preview-mode");
    return () => root.classList.remove("preview-mode");
  }, []);

  if (PAID) return children;
  if (isPreviewExpired()) return <ExpiredScreen />;

  return (
    <>
      <PreviewTopBar />
      {children}
      <PreviewWatermark />
    </>
  );
}
